import _ from 'lodash'
import { SocketId, Dictionary } from '@feedyou/schema'
import { ConnectedSocketUser } from '../../../store/socketServer/types'

export function getOtherUsers(
  connectedUsers: Dictionary<SocketId, ConnectedSocketUser> = {},
  currentUserId?: string,
  socketId?: string
): ConnectedSocketUser[] {
  return _.uniqBy(
    Object.entries(connectedUsers)
      .filter(([key, user]) => user && key !== socketId && user?.id !== currentUserId)
      .map(([_, user]) => user),
    user => {
      return user?.id
    }
  ) as any
}
